import { useMutation, useQuery } from "@tanstack/react-query";
import {
  GoalTemplatesService,
  GoalTemplatesFindAllPayload,
} from "../services/goalTemplates.service";
import { GoalTemplatePayload } from "../domain/goalTemplates.interface";

export const useGoalTemplates = (filters: GoalTemplatesFindAllPayload) => {
  const {
    data: goalTemplates,
    isLoading: isLoadingGoalTemplates,
    isFetching: isFetchingGoalTemplates,
    refetch: refetchGoalTemplates,
  } = useQuery({
    queryKey: ["parca-goal-templates-list"],
    queryFn: () => GoalTemplatesService.findAll(filters),
  });

  return {
    goalTemplates,
    isLoadingGoalTemplates,
    isFetchingGoalTemplates,
    refetchGoalTemplates,
  };
};

export const useCreateGoalTemplate = () => {
  return useMutation({
    mutationFn: (payload: GoalTemplatePayload) =>
      GoalTemplatesService.createOne(payload),
  });
};

export const useUpdateGoalTemplate = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: GoalTemplatePayload;
    }) => GoalTemplatesService.updateOne({ id, payload }),
  });
};

export const useArchiveGoalTemplate = () => {
  return useMutation({
    mutationFn: (id: string) => GoalTemplatesService.archiveOne(id),
  });
};
